import React from 'react';
import _ from 'lodash';

import {
  Table,
  modalUtil
} from 'iron-forge-react-modules';
import {
  Button,
  Skeleton,
  styled
} from '@mui/material';

import * as PrintLabelModal from './PrintLabelModal/PrintLabelModal';
import * as dataService from './dataService';
import * as types from './types';



const BatchButton = styled(Button)({
  paddingTop: 1,
  paddingBottom: 1,
  paddingLeft: 8,
  paddingRight: 8,
  backgroundColor: '#F0F5FF',
  width: 125,
  borderRadius: 8,
  fontSize: 10,
  fontWeight: 600
});

const TableComponent = Table.genTableComponent<types.IColumnId>({
  tableHeaderCellStyle: {
    textAlign: 'center'
  },
  tableBodyCellStyle: {
    border: 'none'
  }
});



export interface IProps {
  storeId?: string;
}

export const FC: React.FC<IProps> = props => {
  const {
    modalType2TargetId,
    setModalIsOpen
  } = modalUtil.useModalTrackers(['printLabel']);
  const {
    queryTuple,
    pageInfo,
    fnQueryPage
  } = dataService.useQuery(props.storeId);

  const loadedRows = React.useMemo(
    () => _.map(queryTuple.data.batches, (batch): types.IRow => ({
      id: batch.referenceNumber,
      columnId2Value: {
        awaitingCarton: {
          type: 'component',
          sortableValue: batch.awaitingCartonCount,
          label: (
            <BatchButton onClick={() => setModalIsOpen('printLabel', batch.id)}>
              {batch.awaitingCartonCount}
            </BatchButton>
          )
        },
        referenceNumber: {
          type: 'string',
          label: batch.referenceNumber
        },
        requestedDate: {
          type: 'string',
          label: batch.requestDate.toFormat('M/d/yy')
        },
        totalBatchCount: {
          type: 'string',
          label: batch.totalCount.toString()
        }
      }
    })),
    [
      queryTuple.data.batches,
      setModalIsOpen
    ]
  );

  const loadingRows = React.useMemo(
    () => _.times(50).map((i): types.IRow => ({
      id: i.toString(),
      columnId2Value: {
        awaitingCarton: {
          type: 'component',
          sortableValue: i,
          label: <Skeleton />
        },
        referenceNumber: {
          type: 'component',
          sortableValue: i,
          label: <Skeleton />
        },
        requestedDate: {
          type: 'component',
          sortableValue: i,
          label: <Skeleton />
        },
        totalBatchCount: {
          type: 'component',
          sortableValue: i,
          label: <Skeleton />
        }
      }
    })),
    []
  );

  return (
    <>
      <TableComponent
        disableSorting
        rows={queryTuple.loading ? loadingRows : loadedRows}
        paginationOptions={Table.pageInfo2PaginationOptions(pageInfo, fnQueryPage)}
        columns={[
          {
            id: 'requestedDate',
            label: "Pre-Alert Date"
          },
          {
            id: 'referenceNumber',
            label: "Reference Number"
          },
          {
            id: 'awaitingCarton',
            label: "Awaiting Label/Carton"
          },
          {
            id: 'totalBatchCount',
            label: "Total RMAs"
          }
        ]} />

      {modalType2TargetId.printLabel && (
        <PrintLabelModal.FC
          returnAuthorizationGroupId={modalType2TargetId.printLabel}
          onClose={() => setModalIsOpen('printLabel', false)}
          onSubmit={() => {
            setModalIsOpen('printLabel', false);
            queryTuple.refetch?.();
          }} />
      )}
    </>
  );
};
